export default {
  users: {
    results: [],
    count: 0,
  },
  users_list: {
    results: [],
  },
  themes: [
    {
      title: 'dark',
      value: 0,
    },
    {
      title: 'light',
      value: 1,
    },
  ],
  roles: [],
  groups: {
    results: [],
  },
  user: {
    contact: {},
  },
  user_phones: {
    results: [],
  },
  langs: ['uz', 'oz', 'ru'],
}
